import type { PendingFeedbackListApi } from '@tempmee/awards';
import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { AWARDS_API_PREFIX } from './awardsApiBase';

/**
 * `GET /feedback/pending` (awards-service #37). Wire contract lives in
 * `@tempmee/awards` (`PendingFeedbackListApi`) — the envelope `cycleId` is the
 * server-resolved cycle every submit must target (GOTU-6571), and each row's
 * `officeId` must be sent as the `x-office` header when submitting from it.
 */
export const getPendingBidFeedback = async (page = 1): Promise<PendingFeedbackListApi> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get<PendingFeedbackListApi>(
    `${AWARDS_API_PREFIX}/feedback/pending`,
    { headers, params: { page } },
  );
  return response.data;
};
